// Module
var code = "<div class=\"image\" data-media-overlay></div> <div class=\"block-4__caption\"> <div class=\"text\"></div> <div class=\"credits\"></div> </div> ";
// Exports
export default code;